const _excluded = ["className", "size"],
  _excluded2 = ["ripple", "size", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import clsx from 'clsx';
import { RippleButton } from "../../base/button";
import { FormSize } from "../../../view-model";
import "./icon-button.style.scss";
export const IconButton = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      className,
      size = FormSize.MD
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(RippleButton, _extends({
    className: clsx('btn-icon-circle circle-primary', {
      'circle-sm': size === FormSize.SM,
      'circle-lg': size === FormSize.LG,
      'circle-xl': size === FormSize.XL
    }, className)
  }, rest, {
    ref: ref
  }));
});
export const IconButtonTransparent = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      ripple = '#bbb',
      size = FormSize.MD,
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/React.createElement(RippleButton, _extends({
    className: clsx('btn-icon-circle circle-transparent', {
      'circle-sm': size === FormSize.SM,
      'circle-lg': size === FormSize.LG,
      'circle-xl': size === FormSize.XL
    }, className),
    ripple: ripple
  }, rest, {
    ref: ref
  }));
});